import { IInputProps, Input } from "components/atoms/Input";
import React from "react";
import { mdiMagnify } from "@mdi/js";
import { Icon } from "components/atoms/Icon";
export const SearchInput = (props: IInputProps) => {
  return <Input {...props} renderAfter={<Icon path={mdiMagnify} />} />;
};
